export default class EpiserverHelper {
  static isInEditMode(): boolean {
    const htmlTags = document.querySelectorAll('html');
    let isInEditMode = false;
    htmlTags.forEach((htmlElement: HTMLElement) => {
      if (htmlElement.hasAttribute('editmode')) {
        isInEditMode = true;
      }
    });
    return isInEditMode;
  }
}
